module.exports = "<p>{{ users.length }} Users on Attaboy:</p>\n\n<app-table\n\t[data]=\"users\"\n\t[head]=\"head\"\n\t[sort]=\"'registration_date'\"\n\t[order]=\"-1\"\n></app-table>\n"


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/admin/users/users.component.html
// module id = ../../../../../src/app/admin/users/users.component.html
// module chunks = main